/**
 * Generic type guard utility to check if a string is one of the values in a readonly array.
 * Useful for creating type-safe checks against string literal arrays.
 *
 * @param value - The string to check
 * @param array - The readonly array of string literals to check against
 * @returns Type predicate indicating whether value is one of the array elements
 *
 * @example
 * const COLORS = ["red", "green", "blue"] as const;
 *
 * if (isOneOf(userInput, COLORS)) {
 *   // userInput is now typed as "red" | "green" | "blue"
 *   console.log(`Valid color: ${userInput}`);
 * }
 */
export const isOneOf = <T extends readonly string[]>(
  value: string,
  array: T,
): value is T[number] => {
  return (array as readonly string[]).includes(value);
};
